<!-- date-picker-flyout.component.html -->
<div class="date-field-wrapper">
    <label class="field-label" *ngIf="label">
        {{ label }}
        <span class="required" *ngIf="required">*</span>
    </label>

    <div class="date-input-container">
        <!-- Text Input Mode (shown when editing) -->
        <div class="date-text-input" *ngIf="isEditingText">
            <input
                #dateInput
                hamInput
                type="text"
                [value]="formattedDate"
                (blur)="onTextInputBlurWithParse()"
                (keydown)="onTextInputKeydown($event)"
                [disabled]="disabled"
                [placeholder]="dateFormatPlaceholder"
                class="date-input-field"
            />
        </div>

        <!-- Button Mode (shown by default) -->
        <div class="date-button-wrapper" *ngIf="!isEditingText">
            <ham-button
                #dateButton
                type="button"
                variant="white"
                class="date-button"
                rightIcon="assets/hamIcons/calendar-month-outline.svg"
                (click)="openFlyout(dateButton)"
                [disabled]="disabled"
                stopPropagation
            >
                <span class="date-display" (click)="onLabelClick($event)">
                    {{ formattedDate || dateFormatPlaceholder }}
                </span>
            </ham-button>

            <!-- Calendar Flyout -->
            <span
                [class]="'menu-flyout ' + flyoutClass"
                #calendarFlyout
                hamFlyout
                *ngIf="!disabled && isOpen"
                [position]="flyoutPosition"
                (closeFlyout)="closeFlyout()"
            >
                <div class="flyout-content">
                    <div class="app-datepicker-wrapper">
                        <mat-calendar [selected]="selectedDate" (selectedChange)="onDateChange($event)"></mat-calendar>

                        <div class="datepicker-actions">
                            <ham-button variant="teal" size="sm" (click)="selectToday()">
                                {{ 'aumico_pm_tasks_select_date_today' | i18next }}
                            </ham-button>
                            <ham-button variant="white" size="sm" (click)="clearDate()">
                                {{ 'aumico_pm_tasks_filter_clear' | i18next }}
                            </ham-button>
                        </div>
                    </div>
                </div>
            </span>
        </div>
    </div>

    <div *ngIf="showError && formControl.touched && formControl.invalid" class="error-message">
        <span *ngIf="formControl.errors?.['required']">
            {{ errorMessage }}
        </span>
    </div>
</div>
